/**************************************************
 * Nombre:       Home_Pasarela
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid, IconButton, Typography} from "@mui/material";
import {ResponsiveContainer, StackedCarousel,} from "react-stacked-center-carousel";
import icono from '../../../Recursos/icono.svg'
import {memo, useContext, useEffect, useRef, useState} from "react";
import {ArrowRightAlt, KeyboardArrowRight} from '@mui/icons-material'
import Tarjeta_Producto from "../../Tarjetas/Tarjeta_Producto";
import {theme} from "../../../Tema";
import {useNavigate} from "react-router";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";
import {contexApp} from "../../../App";
import {obtenerColWheres} from "../../../Servicios/BD/obtenerColWheres";
import {where} from "firebase/firestore";

const Home_Pasarela = () => {
    const {sCell, masSM, sTab, esSafari} = useResponsive()
    const ref = useRef();
    const navigate = useNavigate()
    const cData = useContext(contexApp)
    const [imgs, setImgs] = useState([])
    const [frente, setFrente] = useState(1)
    const [productos, setProductos] = useState([])
    const [prodsModelo, setProdsModelo] = useState([])


    const Card = memo(function (props) {
        const {data, dataIndex} = props;
        const {cover} = data[dataIndex];

        return (
            <div
                style={{
                    height: !masSM ? 450 : 600,
                    userSelect: "none",
                    transform: 'scaleX(-1)',
                    justifyContent: 'flex-end'
                }}
                 className="my-slide-component"
            >
                <img
                    style={{
                        height: "100%",
                        width: esSafari() ?  "70%" : "100%",
                        objectFit: "fill",
                        borderRadius: 0,
                        opacity: frente === dataIndex ? 1 : frente === (dataIndex + 1) ? 0.8 : frente === (dataIndex + 2) ? 0.7 : 0.5,
                        filter: frente === dataIndex ? `blur(0px)` : frente === (dataIndex + 1) ? `blur(1px)` : frente === (dataIndex + 2) ? `blur(2px)` : `blur(4px)`
                    }}
                    draggable={false}
                    src={cover}
                />
            </div>
        );
    });

    const siguiente = () => {
        if (ref.current) {
            ref.current.goBack()
        }

    }


    useEffect(() => {


        if (imgs[frente]) {
            let img = imgs[frente].cover
            setProdsModelo([])
            let arr = []
            for (let i = 0; i < productos.length; i++) {
                let prod = productos[i]
                if (prod.modelos && prod.modelos.includes(img)) {
                    arr.push(prod)
                }

            }

            setProdsModelo(arr)
        }


    }, [frente]);

    useEffect(() => {

        if (cData.actColeccion && cData.actColeccion.id) {
            let arr = cData.actColeccion.imgs

            if (arr) {
                let arrObj = arr.map((it) => {
                        return {cover: it, title: ''}
                    }
                )
                setImgs(arrObj)
            }

            let idCol = cData.actColeccion.id
            let wp = [where('idColeccion', '==', idCol), where('estado', '==', 'Publicado')]
            obtenerColWheres({col: 'productos', wheres: wp}).then((dox) => {

                setProductos(dox.data)
            })

        }

    }, [cData]);

    useEffect(() => {

        if (ref.current) {
            setTimeout(() => {
                siguiente()
            }, 1000)

        }

    }, [ref.current])
    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
        >

            {cData.actColeccion.imgs && cData.actColeccion.imgs.length > 0 &&

                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}
                    sx={{maxWidth: '1400px', px: sCell ? 2 : 6}}
                >

                    <Grid container size={{xs: 12, sm: 6, md: 4}}>
                        <Typography
                            sx={{
                                color: theme.palette.primary.main,
                                fontSize: 14,
                                textAlign: sCell ? 'center' : 'left'
                            }}>
                            {/*cData?.actColeccion?.descripcion*/}
                        </Typography>
                    </Grid>

                    <Grid container size={{xs: 0, sm: 6, md: 8}}>

                    </Grid>

                    <Grid container size={{xs: 12, sm: 7, md: 7}}
                          sx={{zIndex: 2, overflowX: 'hidden', pr: 4, mt: sCell ? 2 : 0}}>
                        {imgs.length > 0 &&
                            <ResponsiveContainer
                                carouselRef={ref}
                                render={(parentWidth, carouselRef) => {
                                    let currentVisibleSlide = !masSM ? 5 : 7;
                                    // if (parentWidth <= 1440) currentVisibleSlide = 9;
                                    // if (parentWidth <= 1080) currentVisibleSlide = 1;
                                    return (
                                        <StackedCarousel
                                            ref={carouselRef}
                                            slideComponent={Card}
                                            slideWidth={sCell ? 290 : sTab ? 350  : 600}
                                            carouselWidth={parentWidth * 2}
                                            data={imgs}
                                            currentVisibleSlide={currentVisibleSlide}
                                            maxVisibleSlide={!masSM ? 5 : 7}
                                            useGrabCursor
                                            fadeDistance={0}
                                            onActiveSlideChange={(e) => setFrente(e)}
                                           // customScales={[1, 1, 1, 1,1]}
                                        />
                                    );
                                }}
                            />
                        }

                    </Grid>


                    <Grid container size={{xs: 12, sm: 5, md: 4}}
                          sx={{
                             // background: 'linear-gradient(270deg, #FFF 75.92%, rgba(255, 237, 237, 0.00) 99.91%)',
                              backgroundColor: '#fff',
                              height: !masSM ? 'auto' : 650,
                              zIndex: 2,
                              mt: sCell ? 10 : sTab ? -8 : -10,
                              ml: sCell ? 0 : sTab ? -4 : -5,
                              pl: sCell ? 0 : sTab ? 4 : 5,
                              mr: sTab ? -5 : 0
                          }}
                    >


                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'center'}
                            size={{xs: 12, sm: 12, md: 12}}>

                            {masSM &&
                                <Grid container size={{xs: 12, sm: 12, md: 2}}>
                                    <IconButton
                                        onClick={() => siguiente()}
                                        sx={{backgroundColor: '#79625450'}}>
                                        <KeyboardArrowRight/>
                                    </IconButton>
                                </Grid>
                            }

                            <Grid container size={{xs: 12, sm: 12, md: 10}} sx={{px: sCell ? 4 : 0, pl: 4}}>

                                <Grid
                                    container
                                    justifyContent={'center'}
                                    alignItems={'flex-start'}
                                    size={{xs: 12, sm: 12, md: 12}}
                                    spacing={3}
                                >

                                    {prodsModelo.map((it, index) => {
                                        return (
                                            <Grid container size={{xs: 6, sm: 6, md: 6}}>
                                                <Tarjeta_Producto item={it}/>
                                            </Grid>
                                        )
                                    })}

                                </Grid>


                            </Grid>


                        </Grid>

                    </Grid>

                    {!sCell &&
                        <Grid container size={{xs: 12, sm: 7, md: 7}}
                              sx={{
                                  justifyContent: 'center',
                                  transition: 'all .2s ease-in-out',
                                  mt: sCell ? -70 : sTab ? -50 : -75,
                                  zIndex: 1,
                                  opacity: 0.2,
                                // transform: `rotate(${frente * -45}deg)`
                              }}>
                            <img src={icono} width={sCell ? '100%' : '80%'} height={'auto'}/>
                        </Grid>
                    }

                    <Grid container size={{xs: 12, sm: 12, md: 12}}
                          sx={{mt: sCell ? 6 : 1, ml: sCell ? 0 : -2, justifyContent: sCell ? 'center' : 'left'}}>
                        <Button
                            onClick={() => navigate('/DetalleCol/' + cData.actColeccion.id)}
                            variant={sCell ? 'contained' : 'text'} endIcon={<ArrowRightAlt/>}
                            sx={{px: sCell ? 4 : 2}}
                        >Ver toda la colección</Button>
                    </Grid>

                </Grid>
            }

        </Grid>
    )

}
export default Home_Pasarela



